import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import SaveIcon from "@mui/icons-material/Save";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import NoteHistorique from "./NoteHistorique";

const apiUrl = process.env.REACT_APP_API_URL;

export default function DevisDialog({ visible, onHide, leadData, onDevisGenerated, forceNew = false }) {
  const [formule, setFormule] = useState("avec_alcool");
  const [prixParPersonne, setPrixParPersonne] = useState(20);
  const [remise, setRemise] = useState(0);
  const [generating, setGenerating] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [devisInfo, setDevisInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nbPersonnes, setNbPersonnes] = useState(leadData?.nbpers || 0);
  const [nbBarmen, setNbBarmen] = useState(1);
  const [structure, setStructure] = useState("tuk_tuk");
  const [options, setOptions] = useState([]);
  
  // Status state
  const [selectedStatus, setSelectedStatus] = useState("");

  // Calculs
  const sousTotalPrestation = nbPersonnes * prixParPersonne;
  const sousTotalOptions = options.reduce((sum, opt) => sum + (opt.prix || 0), 0);
  const sousTotal = sousTotalPrestation + sousTotalOptions;
  const montantRemise = (sousTotal * remise) / 100;
  const total = sousTotal - montantRemise;

  const [hasChanges, setHasChanges] = useState(false);

  const [tempNom, setTempNom] = useState(leadData?.nomPrenom || "");
  const [tempEmail, setTempEmail] = useState(leadData?.email || "");
  const [tempTel, setTempTel] = useState(leadData?.tel || "");
  const [tempLieu, setTempLieu] = useState(leadData?.lieu || "");
  const [tempNbpers, setTempNbpers] = useState(leadData?.nbpers || "");
  const [tempDateEvent, setTempDateEvent] = useState(leadData?.dateEvent || "");
  const [tempTypeBar, setTempTypeBar] = useState(leadData?.type_bar || "");
  const [tempMore, setTempMore] = useState(leadData?.plusInfos || "");
  const [tempDateUpdate, setTempDateUpdate] = useState(leadData?.dateUpdate || "");


  // Note interne
  const [note, setNote] = useState("");
  const [savingNote, setSavingNote] = useState(false);
  const [noteHistoryRefreshKey, setNoteHistoryRefreshKey] = useState(0);

  // Accordéons
  const [openClientInfo, setOpenClientInfo] = useState(true);
  const [openEventInfo, setOpenEventInfo] = useState(false);
  const [openNote, setOpenNote] = useState(false);




  useEffect(() => {
    if (leadData) {
      const hasAnyChange =
        tempNom !== (leadData.nomPrenom || "") ||
        tempEmail !== (leadData.email || "") ||
        tempTel !== (leadData.tel || "") ||
        tempLieu !== (leadData.lieu || "") ||
        tempNbpers !== (leadData.nbpers || "") ||
        tempDateEvent !== (leadData.dateEvent || "") ||
        tempTypeBar !== (leadData.type_bar || "") ||
        tempMore !== (leadData.plusInfos || "");

      setHasChanges(hasAnyChange);
    }
  }, [tempNom, tempEmail, tempTel, tempLieu, tempNbpers, tempDateEvent, tempTypeBar, tempMore, leadData]);

  useEffect(() => {
    if (leadData) {
      setTempNom(leadData.nomPrenom || "");
      setTempEmail(leadData.email || "");
      setTempTel(leadData.tel || "");
      setTempLieu(leadData.lieu || "");
      setTempNbpers(leadData.nbpers || "");
      setTempDateEvent(leadData.dateEvent || "");
      setTempTypeBar(leadData.type_bar || "");
      setTempMore(leadData.plusInfos || "");
      setHasChanges(false);

      if (leadData.etat !== undefined && leadData.etat !== null) {
        setSelectedStatus(String(leadData.etat));
      } else {
        setSelectedStatus("");
      }

      setTempDateUpdate(new Date(leadData?.dateUpdate).toLocaleDateString("fr-FR"));

    }
  }, [leadData]);


  

  const handleSaveClient = async () => {
    try {
      await axios.post(`${apiUrl}/IHM/api/update_ficheLead.php`, {
        idLead: leadData.idLead,
        nom: tempNom,
        telephone: tempTel,
        email: tempEmail,
        lieu: tempLieu,
        nbpers: tempNbpers,
        typeBar: tempTypeBar,
        more: tempMore,
        dateEvent: tempDateEvent,
        adminMod: localStorage.getItem("us"),
      });

      setHasChanges(false);
      setSnackbarMessage("Informations client mises à jour");
      setOpenSnackbar(true);

      if (onDevisGenerated) onDevisGenerated();
    } catch (error) {
      console.error("Erreur de mise à jour :", error);
      setSnackbarMessage("Erreur lors de la sauvegarde");
      setOpenSnackbar(true);
    }
  };

  useEffect(() => {
    if (leadData?.nbpers) setNbPersonnes(leadData.nbpers);
  }, [leadData]);

  useEffect(() => {
    if (visible && leadData?.idLead && !forceNew) {
      checkExistingDevis();
    } else if (visible && forceNew) {
      setDevisInfo(null);
      setLoading(false);
    }
  }, [visible, leadData, forceNew]);

  useEffect(() => {
    if (forceNew) {
      resetForm();
    }
  }, [forceNew]);

  const checkExistingDevis = async () => {
    setLoading(true);
    setDevisInfo(null);

    if (forceNew) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${apiUrl}/IHM/api/generer_devis.php?lead_id=${leadData.idLead}`);
      if (response.data.a_devis == 1) {
        setDevisInfo({
          a_devis: response.data.a_devis,
          numero_devis: response.data.dernier_devis_id,
          lien_devis: response.data.lien_devis,
          lien_pdf: response.data.lien_pdf,
          token_devis: response.data.token_devis,
          montant_devis: response.data.montant_total || 0,
          date_devis: response.data.date_devis || new Date().toISOString(),
          idVosFactures: response.data.idVosFactures,
          statut_devis: response.data.statut_devis || "brouillon",
        });
      } else {
        setDevisInfo(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const ajouterOption = () => {
    setOptions([...options, { titre: "", description: "", prix: 0 }]);
  };

  const supprimerOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const modifierOption = (index, champ, valeur) => {
    const newOptions = [...options];
    newOptions[index][champ] = valeur;
    setOptions(newOptions);
  };

  const handleGenererDevis = async () => {
    if (!leadData) return;
    setGenerating(true);
    try {
      const response = await axios.post(`${apiUrl}/IHM/api/generer_devis.php`, {
        lead_id: leadData.idLead,
        nom: leadData.nomPrenom,
        email: leadData.email,
        tel: leadData.tel,
        lieu: leadData.lieu,
        nb_personnes: nbPersonnes,
        nb_barmen: nbBarmen,
        formule: formule,
        prix_par_personne: prixParPersonne,
        remise: remise,
        structure: structure,
        options: options,
        is_new_version: forceNew,
        adminMod: localStorage.getItem("us"),
      });

      if (response.data.success) {
        setDevisInfo({
          a_devis: 1,
          lien_devis: response.data.devis_url,
          lien_pdf: response.data.pdf_url,
          numero_devis: response.data.devis_number,
          montant_devis: response.data.montant
        });

        setSnackbarMessage("Devis généré avec succès !");
        setOpenSnackbar(true);
        if (onDevisGenerated) onDevisGenerated();

      } else {
        setSnackbarMessage(response.data.message || "Erreur");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Erreur lors de la génération");
      setOpenSnackbar(true);
    } finally {
      setGenerating(false);
    }
  };

  const resetForm = () => {
    setFormule("avec_alcool");
    setPrixParPersonne(20);
    setRemise(0);
    setNbPersonnes(leadData?.nbpers || 0);
    setNbBarmen(1);
    setStructure("tuk_tuk");
    setOptions([]);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .custom-dialog .p-dialog-content {
        padding: 1.5rem;
        color: #1f2937;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }
      .clean-input {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        box-sizing: border-box;
      }
      .clean-input:focus {
        outline: none;
        border-color: #322915;
      }
      .clean-textarea {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        resize: vertical;
        box-sizing: border-box;
      }
      .clean-textarea:focus {
        outline: none;
        border-color: #322915;
      }
      .clean-select {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        box-sizing: border-box;
        appearance: auto;
        cursor: pointer;
      }
      .clean-select:focus {
        outline: none;
        border-color: #322915;
      }
      .accordion-header {
        border-bottom: 1px solid #e5e7eb;
        padding: 12px 0;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        user-select: none;
        cursor: pointer;
      }
      .accordion-title {
        font-size: 12.5px;
        font-weight: 600;
        color: #322915;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .accordion-title i {
        color: #6b7280;
        font-size: 14px;
      }
      .static-section-title {
        font-size: 12.5px;
        font-weight: 600;
        color: #322915;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        margin-top: 20px;
        margin-bottom: 12px;
        padding-top: 14px;
        border-top: 1px solid #e5e7eb;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .static-section-title i {
        color: #6b7280;
        font-size: 14px;
      }
      .field-label {
        font-size: 12px;
        color: #6b7280;
        display: block;
        margin-bottom: 4px;
      }
      .brand-btn-primary {
        background-color: #322915 !important;
        border-color: #322915 !important;
        color: #ffffff !important;
        border-radius: 6px !important;
        font-weight: 500 !important;
      }
      .brand-btn-primary:hover {
        opacity: 0.9;
      }
      .devis-card {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 14px;
        background: #fafafa;
      }
      .btn-outlined-clean {
        border-color: #e5e7eb !important;
        color: #322915 !important;
        font-size: 13px !important;
        border-radius: 6px !important;
      }
      .btn-outlined-clean:hover {
        background-color: #f9fafb !important;
      }
      .status-select-wrapper {
        padding: 12px 0 8px 0;
        display: flex;
        align-items: center;
        gap: 12px;
      }
      .status-select-wrapper .field-label {
        margin-bottom: 0;
        font-weight: 500;
        color: #322915;
        font-size: 12.5px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .status-select-wrapper .clean-select {
        width: 180px;
        flex-shrink: 0;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setSelectedStatus(newStatus);

    if (!newStatus) return;

    try {
      const data = {
        idLead: leadData.idLead,
        etat: newStatus,
        note: '',
        adminMod: localStorage.getItem("us"),
      };

      const response = await axios.put(`${apiUrl}/IHM/api/lead.php`, data);
      if (response.data) {
        setSnackbarMessage(`État changé avec succès`);
        setOpenSnackbar(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error("Erreur:", error);
      setSnackbarMessage("Erreur lors du changement d'état");
      setOpenSnackbar(true);
      // Revert selection on error
      setSelectedStatus(leadData?.etat || "");
    }
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg" style={{ color: "#322915" }}>
        Fiche client & devis
      </span>
    </div>
  );

  const handleSaveNote = async () => {
    if (!leadData || !note.trim()) return;
    setSavingNote(true);
    try {
      const response = await axios.put(`${apiUrl}/IHM/api/lead.php`, {
        idLead: leadData.idLead,
        note: note,
        adminMod: localStorage.getItem("us"),
        noteOnly: true,
      });

      if (response.data) {
        setSnackbarMessage("Note enregistrée");
        setOpenSnackbar(true);
        setNote("");
        setNoteHistoryRefreshKey((k) => k + 1);
        if (onDevisGenerated) onDevisGenerated();
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de la note :", error);
      setSnackbarMessage("Erreur lors de l'enregistrement de la note");
      setOpenSnackbar(true);
    } finally {
      setSavingNote(false);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "48vw", maxWidth: "720px" }}
        modal
        onHide={() => {
          onHide();
          resetForm();

          setOpenClientInfo(true);
          setOpenEventInfo(false);
          setOpenNote(false);
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div>
          <div className="status-select-wrapper">
            <select
              className="clean-select"
              value={selectedStatus}
              onChange={handleStatusChange}
            >
              <option value="">Sélectionner</option>
              <option value="1">Nouvelles</option>
              <option value="2">Relances</option>
              <option value="6">Envoyés</option>
              <option value="4">Réalisés</option>
              <option value="5">Abandons</option>
            </select>

            {tempDateUpdate && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#6b7280",
                  marginLeft: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                modifié le : {tempDateUpdate}
              </span>
            )}
          </div>

          {/* Section 1 ---- Infos Client (Accordion / Toggle) */}
          <div
            className="accordion-header"
            onClick={() => setOpenClientInfo((v) => !v)}
          >
            <span className="accordion-title">
              <i className="pi pi-user"></i> Informations client
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {hasChanges && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSaveClient();
                  }}
                  style={{
                    borderRadius: "4px",
                    color: "#fff",
                    width: "22px",
                    height: "22px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: "#322915",
                  }}
                >
                  <SaveIcon sx={{ fontSize: 13 }} />
                </span>
              )}
              {openClientInfo ? (
                <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
              ) : (
                <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
              )}
            </div>
          </div>

          {openClientInfo && (
            <div className="grid mb-3">
              <div className="col-12 md:col-4">
                <label className="field-label">Nom</label>
                <input
                  className="clean-input"
                  value={tempNom}
                  onChange={(e) => setTempNom(e.target.value)}
                />
              </div>
              <div className="col-12 md:col-4">
                <label className="field-label">Email</label>
                <input
                  className="clean-input"
                  value={tempEmail}
                  onChange={(e) => setTempEmail(e.target.value)}
                />
              </div>
              <div className="col-12 md:col-4">
                <label className="field-label">Téléphone</label>
                <input
                  className="clean-input"
                  value={tempTel}
                  onChange={(e) => setTempTel(e.target.value)}
                />
              </div>
            </div>
          )}

          {/* Section 2 ---- Événement (Accordion) */}
          <div
            className="accordion-header"
            onClick={() => setOpenEventInfo((v) => !v)}
          >
            <span className="accordion-title">
              <i className="pi pi-calendar"></i> Détails Événement
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {hasChanges && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSaveClient();
                  }}
                  style={{
                    borderRadius: "4px",
                    color: "#fff",
                    width: "22px",
                    height: "22px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: "#322915",
                  }}
                >
                  <SaveIcon sx={{ fontSize: 13 }} />
                </span>
              )}
              {openEventInfo ? (
                <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
              ) : (
                <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
              )}
            </div>
          </div>

          {openEventInfo && (
            <>
              <div className="grid mb-2">
                <div className="col-12 md:col-3">
                  <label className="field-label">Nb personnes</label>
                  <input
                    type="number"
                    className="clean-input"
                    value={tempNbpers}
                    onChange={(e) => setTempNbpers(e.target.value)}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <label className="field-label">Lieu</label>
                  <input
                    className="clean-input"
                    value={tempLieu}
                    onChange={(e) => setTempLieu(e.target.value)}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <label className="field-label">Date</label>
                  <input
                    type="date"
                    className="clean-input"
                    value={tempDateEvent}
                    onChange={(e) => setTempDateEvent(e.target.value)}
                  />
                </div>
                <div className="col-12 md:col-3">
                  <label
                    className="field-label"
                    style={{ marginBottom: "9px" }}
                  >
                    Type de bar
                  </label>
                  <select
                    className="clean-select mt-[5px]"
                    value={tempTypeBar}
                    onChange={(e) => setTempTypeBar(e.target.value)}
                  >
                    <option value="avec_alcool">Avec alcool</option>
                    <option value="sans_alcool">Sans alcool</option>
                    <option value="avec_alcool, sans_alcool">
                      Avec et sans alcool
                    </option>
                  </select>
                </div>
              </div>

              <div className="grid mb-3">
                <div className="col-12">
                  <label className="field-label">
                    Informations complémentaires
                  </label>
                  <textarea
                    className="clean-textarea"
                    value={tempMore}
                    onChange={(e) => setTempMore(e.target.value)}
                    rows={2}
                  />
                </div>
              </div>
            </>
          )}

          {/* Section 3 ---- Notes & Historique (Accordion) */}
          <div
            className="accordion-header"
            onClick={() => setOpenNote((v) => !v)}
          >
            <span className="accordion-title">
              <i className="pi pi-comments"></i> Notes & Historique
            </span>
            {openNote ? (
              <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
            ) : (
              <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
            )}
          </div>

          {openNote && (
            <>
              <div className="grid mb-3">
                <div className="col-12">
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="text"
                      className="clean-input"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      placeholder="Écrire une note..."
                      style={{ flex: 1 }}
                    />
                    <Button
                      label={savingNote ? "..." : "Ajouter"}
                      className="brand-btn-primary p-button-sm"
                      style={{ height: "38px", fontSize: "13px" }}
                      onClick={handleSaveNote}
                      disabled={savingNote || !note.trim()}
                    />
                  </div>
                </div>
              </div>

              <div className="grid mb-2">
                <div className="col-12">
                  <NoteHistorique
                    idLead={leadData?.idLead}
                    refreshKey={noteHistoryRefreshKey}
                  />
                </div>
              </div>
            </>
          )}

          {/* SECTION FIXE : DEVIS (SANS TOGGLE) */}
          <div className="static-section-title">
            <i className="pi pi-file"></i>
            {devisInfo?.a_devis && !forceNew
              ? "Devis actuel"
              : "Génération du devis"}
          </div>

          {loading ? (
            <div className="flex justify-content-center p-3">
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "1.2rem", color: "#322915" }}
              ></i>
            </div>
          ) : !devisInfo?.a_devis || forceNew ? (
            <>
              <div className="grid mb-2">
                <div className="col-12">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(85px, 1fr))",
                      gap: "10px",
                      alignItems: "end",
                    }}
                  >
                    <div>
                      <label className="field-label">Nb pers</label>
                      <input
                        type="number"
                        className="clean-input"
                        value={nbPersonnes}
                        onChange={(e) =>
                          setNbPersonnes(parseInt(e.target.value) || 0)
                        }
                        min={1}
                      />
                    </div>
                    <div>
                      <label className="field-label">Barmans</label>
                      <input
                        type="number"
                        className="clean-input"
                        value={nbBarmen}
                        onChange={(e) =>
                          setNbBarmen(parseInt(e.target.value) || 1)
                        }
                        min={1}
                      />
                    </div>
                    <div>
                      <label className="field-label">Structure</label>
                      <select
                        className="clean-select"
                        value={structure}
                        onChange={(e) => setStructure(e.target.value)}
                      >
                        <option value="tuk_tuk">Tuk-Tuk</option>
                        <option value="elegance">Élégance</option>
                        <option value="both">Les deux</option>
                      </select>
                    </div>
                    <div>
                      <label className="field-label">Formule</label>
                      <select
                        className="clean-select"
                        value={formule}
                        onChange={(e) => setFormule(e.target.value)}
                      >
                        <option value="avec_alcool">Avec alcool</option>
                        <option value="sans_alcool">Sans alcool</option>
                      </select>
                    </div>
                    <div>
                      <label className="field-label">Prix/p (€)</label>
                      <input
                        type="number"
                        className="clean-input"
                        value={prixParPersonne}
                        onChange={(e) =>
                          setPrixParPersonne(parseFloat(e.target.value) || 0)
                        }
                        min={0}
                      />
                    </div>
                    <div>
                      <label className="field-label">Remise (%)</label>
                      <input
                        type="number"
                        className="clean-input"
                        value={remise}
                        onChange={(e) =>
                          setRemise(parseFloat(e.target.value) || 0)
                        }
                        min={0}
                        max={100}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Options */}
              <div className="grid">
                <div className="col-12">
                  {options.map((option, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "flex-end",
                        marginTop: "8px",
                      }}
                    >
                      <div style={{ flex: 2 }}>
                        <input
                          className="clean-input"
                          value={option.titre}
                          onChange={(e) =>
                            modifierOption(index, "titre", e.target.value)
                          }
                          placeholder="Titre de l'option"
                        />
                      </div>
                      <div style={{ flex: 2 }}>
                        <input
                          className="clean-input"
                          value={option.description}
                          onChange={(e) =>
                            modifierOption(index, "description", e.target.value)
                          }
                          placeholder="Description"
                        />
                      </div>
                      <div style={{ width: "85px" }}>
                        <input
                          type="number"
                          className="clean-input"
                          value={option.prix}
                          onChange={(e) =>
                            modifierOption(
                              index,
                              "prix",
                              parseFloat(e.target.value) || 0,
                            )
                          }
                          placeholder="Prix €"
                          min={0}
                        />
                      </div>
                      <button
                        onClick={() => supprimerOption(index)}
                        style={{
                          height: "38px",
                          width: "38px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          background: "#ffffff",
                          color: "#9ca3af",
                          cursor: "pointer",
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}

                  <button
                    onClick={ajouterOption}
                    style={{
                      background: "none",
                      border: "1px dashed #d1d5db",
                      borderRadius: "6px",
                      width: "100%",
                      padding: "8px",
                      marginTop: "10px",
                      fontSize: "13px",
                      color: "#322915",
                      cursor: "pointer",
                    }}
                  >
                    + Ajouter une option
                  </button>
                </div>
              </div>

              {/* Récapitulatif épuré */}
              <div className="grid mt-2">
                <div className="col-12">
                  <div
                    style={{
                      borderTop: "1px solid #f3f4f6",
                      paddingTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "13px",
                        color: "#6b7280",
                        marginBottom: "4px",
                      }}
                    >
                      <span>Prestation ({nbPersonnes} pers.)</span>
                      <span style={{ fontWeight: 500 }}>
                        {sousTotalPrestation.toFixed(2)} €
                      </span>
                    </div>
                    {options.map((opt, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "13px",
                          color: "#6b7280",
                          marginBottom: "4px",
                        }}
                      >
                        <span>{opt.titre || "Option"}</span>
                        <span style={{ fontWeight: 500 }}>
                          {opt.prix.toFixed(2)} €
                        </span>
                      </div>
                    ))}
                    {remise > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "13px",
                          color: "#dc2626",
                          marginBottom: "4px",
                        }}
                      >
                        <span>Remise ({remise}%)</span>
                        <span style={{ fontWeight: 500 }}>
                          - {montantRemise.toFixed(2)} €
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "8px",
                        fontWeight: 600,
                        fontSize: "14.5px",
                        color: "#322915",
                      }}
                    >
                      <span>Total TTC</span>
                      <span>{total.toFixed(2)} €</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid mt-3">
                <div className="col-12">
                  <Button
                    label={
                      generating ? "Génération en cours..." : "Créer le devis"
                    }
                    className="w-full brand-btn-primary"
                    style={{
                      padding: "0.7rem",
                      fontSize: "13.5px",
                      justifyContent: "center",
                    }}
                    onClick={handleGenererDevis}
                    disabled={generating || nbPersonnes === 0}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Devis existant - Affichage sobre */}
              <div className="devis-card mb-3">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div style={{ fontSize: "11px", color: "#6b7280" }}>
                      N° DEVIS
                    </div>
                    <div
                      style={{
                        fontSize: "14.5px",
                        fontWeight: 600,
                        color: "#322915",
                      }}
                    >
                      {devisInfo.numero_devis}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: "11px", color: "#6b7280" }}>
                      DATE
                    </div>
                    <div style={{ fontSize: "13.5px", color: "#322915" }}>
                      {new Date(devisInfo.date_devis).toLocaleDateString(
                        "fr-FR",
                      )}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: "11px", color: "#6b7280" }}>
                      MONTANT
                    </div>
                    <div
                      style={{
                        fontSize: "14.5px",
                        fontWeight: 600,
                        color: "#322915",
                      }}
                    >
                      {parseFloat(devisInfo.montant_devis).toFixed(2)} €
                    </div>
                  </div>
                </div>
              </div>

              {/* Boutons d'action épurés avec icônes intégrées */}
              <div className="grid">
                <div className="col-12">
                  <div className="flex gap-2 justify-content-end flex-wrap">
                    {devisInfo.lien_pdf && (
                      <Button
                        label="PDF"
                        icon="pi pi-file-pdf"
                        outlined
                        className="btn-outlined-clean"
                        onClick={() =>
                          window.open(devisInfo.lien_pdf, "_blank")
                        }
                      />
                    )}
                    {devisInfo.lien_devis && (
                      <Button
                        label="Consulter"
                        icon="pi pi-eye"
                        outlined
                        className="btn-outlined-clean"
                        onClick={() =>
                          window.open(devisInfo.lien_devis, "_blank")
                        }
                      />
                    )}
                    <Button
                      label="Modifier"
                      icon="pi pi-pencil"
                      outlined
                      className="btn-outlined-clean"
                      onClick={() =>
                        window.open(
                          `https://unptittukenplus.vosfactures.fr/invoices/${devisInfo.idVosFactures}/edit`,
                          "_blank",
                        )
                      }
                    />
                    <Button
                      label="Envoyer par email"
                      icon="pi pi-send"
                      className="brand-btn-primary"
                      style={{ fontSize: "13px" }}
                      onClick={() => {
                        axios
                          .post(`${apiUrl}/IHM/api/sendMailDevis.php`, {
                            id: leadData.idLead,
                            adminMod: localStorage.getItem("us"),
                          })
                          .then((res) => {
                            if (res.data.success) {
                              setSnackbarMessage(
                                `Devis envoyé à ${leadData.email}`,
                              );
                              setOpenSnackbar(false);

                              setDevisInfo({
                                ...devisInfo,
                                statut_devis: "envoye",
                              });
                              window.location.reload();
                            } else {
                              setSnackbarMessage(
                                res.data.message || "Envoi impossible",
                              );
                              setOpenSnackbar(true);
                            }
                          })
                          .catch((err) => {
                            console.error("Erreur envoi mail:", err);
                            setSnackbarMessage("Impossible d'envoyer l'email");
                            setOpenSnackbar(true);
                          });
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Dialog>
    </>
  );
}